module.exports = __webpack_public_path__ + "img/蜂蜜2.9c388ff7.png";